import { styled } from '@mui/material/styles'

const FullHeightContainer = styled('div')({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
})

export default FullHeightContainer
